<template>
  <div class="w-full h-full flex flex-col">
    <div class="flex justify-between items-center">
      <div class="title text-lg mb-10px cursor-pointer">
        <el-page-header
          v-if="pageType === 'read'"
          @back="$emit('cancel')"
          content="详情"
        ></el-page-header>
        <span v-else class="border-l-3 border-color-primary pl-10px text-18px">{{
          pageType === 'create' ? '新增' : '编辑'
        }}</span>
      </div>
    </div>
    <div
      v-loading="pageLoading"
      class="w-full overflow-y-auto overflow-x-hidden pr-40px h-0 flex-auto flex flex-col"
      :class="[pageType === 'read' ? 'detail-height' : 'custom-height']"
    >
      <el-form
        ref="form"
        label-width="140px"
        :rules="rules"
        :model="formData"
        :disabled="canChange"
        class="h-full"
      >
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              ref="examName"
              label="考试名称"
              prop="examName"
              :rules="[
                {
                  required: true,
                  message: `请输入`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-input
                v-model="formData.examName"
                placeholder="请输入试卷名称"
                maxlength="20"
                show-word-limit
                clearable
                :disabled="canRead"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item label="考试编号" prop="examCode" ref="examCode">
              <el-input
                v-model="formData.examCode"
                placeholder="请输入"
                maxlength="20"
                show-word-limit
                clearable
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              ref="examCategory"
              label="考试类型"
              prop="examCategory"
              :rules="[
                {
                  required: true,
                  message: `请选择`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-select
                v-model="formData.examCategory"
                class="w-full"
                size="small"
                placeholder="请选择"
                :disabled="canRead"
              >
                <el-option
                  v-for="item in pagerTypeList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              ref="dateArr"
              label="考试时间"
              prop="dateArr"
              :rules="[
                {
                  required: true,
                  validator: validatorDateArr,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-date-picker
                class="w-full"
                style="width: 100%"
                v-model="formData.dateArr"
                type="datetimerange"
                size="small"
                range-separator="-"
                :start-placeholder="`${$t('开始日期')}`"
                :end-placeholder="`${$t('结束日期')}`"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                @change="dateChange"
                :picker-options="pickerOptions"
                @focus="dateFocus"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              label="是否任意时间参加"
              prop="isAnyTime"
              :rules="[
                {
                  required: true,
                  message: '请选择',
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-select
                v-model="formData.isAnyTime"
                class="w-full"
                size="small"
                placeholder="请选择"
                :disabled="canRead"
                @change="isAnyTimeChange"
              >
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              ref="examTotalScore"
              label="考试总分"
              prop="examTotalScore"
              :rules="[
                {
                  required: true,
                  message: `请选择`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-input v-model.number="formData.examTotalScore" disabled />
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item label="积分" prop="integral" ref="integral">
              <el-input-number
                class="w-full"
                :controls="false"
                :max="999999999"
                :min="1"
                :precision="0"
                maxlength="10"
                show-word-limit
                :placeholder="'请输入'"
                v-model.number="formData.integral"
                clearable
                :disabled="canRead"
              ></el-input-number>
            </el-form-item>
          </el-col> -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item ref="sponsor" label="发起人" prop="sponsor">
              <!-- <MultiplePersonSelect
                :disabled="['read'].includes(pageType)"
                class="w-full"
                placeholder="请输入"
                v-model="formData.sponsor"
              ></MultiplePersonSelect> -->
              <el-input
                size="small"
                v-model="formData.sponsorName"
                readonly
                placeholder="请选择"
                class="flex-1"
                :disabled="canRead"
              >
                <template slot="append">
                  <el-button
                    @click="openTreeSelect(formData, 'sponsor', canRead)"
                    type="primary"
                    :disabled="false"
                    >{{ canRead ? '查看' : '选择' }}</el-button
                  >
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              label="是否关联积分"
              prop="associateIntegral"
              :rules="[
                {
                  required: true,
                  message: `请选择`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-switch
                v-model="formData.associateIntegral"
                :disabled="canRead"
                @change="associateIntegralChange"
              ></el-switch>
            </el-form-item>
          </el-col>
          -->
          <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              label="赋分类型"
              v-if="formData.associateIntegral"
              prop="integralType"
              :rules="[
                {
                  required: true,
                  message: `请选择`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-select
                v-model="formData.integralType"
                class="w-full"
                size="small"
                placeholder="请选择"
                :disabled="canRead"
              >
                <el-option
                  v-for="item in integralTypeList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          -->
          <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item
              v-if="formData.associateIntegral"
              label="分值"
              prop="integrals"
              :rules="[
                {
                  required: true,
                  message: `请选择`,
                  trigger: ['change', 'blur'],
                },
              ]"
            >
              <el-select
                v-model="formData.integrals"
                class="w-full"
                size="small"
                placeholder="请选择"
                :disabled="canRead"
              >
                <el-option
                  v-for="item in integralsList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          -->
          <el-col :span="24">
            <el-form-item label="考试公告" prop="examNotice" ref="examNotice">
              <el-input
                maxlength="500"
                show-word-limit
                type="textarea"
                v-model="formData.examNotice"
                :disabled="canRead"
                :rows="8"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="考试场次"
          :rules="[
            {
              required: true,
              message: `请选择`,
              trigger: ['change', 'blur'],
            },
          ]"
        >
          <el-button type="primary" size="mini" class="w-100px" @click="addExamScene"
            >添加</el-button
          >
        </el-form-item>
        <el-row class="pl-80px">
          <el-col :span="24" class="h-full">
            <el-table
              :data="formData.examSessions"
              border
              class="w-full mb-20px"
              stripe
              row-key="id"
              ref="table"
              :key="updateTable"
            >
              <el-table-column label="考试场次" type="index" width="100"></el-table-column>
              <el-table-column label="采用试卷" prop="usingExamPaper" min-width="200">
                <template slot="header">
                  <span class="text-red-500">*</span>
                  采用试卷
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.usingExamPaper`"
                    class="mt-20px"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.usingExamPaper`"
                    :rules="[
                      {
                        required: true,
                        validator: (rule, value, callback) =>
                          paperValidator(rule, value, callback, scope.$index),
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <MultipleExamSelect
                      :disabled="canRead"
                      :disabledIds="allIds"
                      class="w-full"
                      placeholder="请输入"
                      v-model="scope.row.usingExamPaper"
                      @changeSelectionData="(data) => changeSelectionData(data, scope.row)"
                      :multiple="false"
                    ></MultipleExamSelect>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                label="场次名称"
                prop="examSessionName"
                width="200"
                show-overflow-tooltip
              >
                <template slot="header">
                  <span class="text-red-500">*</span>
                  场次名称
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.examSessionName`"
                    class="mt-20px relative"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.examSessionName`"
                    :rules="[
                      {
                        required: true,
                        validator: (rule, value, callback) =>
                          nameValidator(rule, value, callback, scope.$index),
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-popover
                      trigger="hover"
                      placement="top-start"
                      :content="scope.row.examSessionName"
                      class="absoulate"
                    >
                      <el-input
                        maxlength="20"
                        show-word-limit
                        :placeholder="'请输入'"
                        v-model="scope.row.examSessionName"
                        clearable
                        :disabled="canRead"
                        slot="reference"
                      ></el-input>
                    </el-popover>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="建议考试时长(分钟)"
                prop="suggestedExamDuration"
                show-overflow-tooltip
                width="160"
              >
                <template slot="header">
                  <span class="text-red-500">*</span>
                  建议考试时长(分钟)
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.suggestedExamDuration`"
                    class="mt-20px"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.suggestedExamDuration`"
                    :rules="[
                      {
                        required: true,
                        message: '请输入',
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-input
                      maxlength="5"
                      show-word-limit
                      :placeholder="'请输入'"
                      v-model.number="scope.row.suggestedExamDuration"
                      clearable
                      :disabled="canRead"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column> -->
              <template v-if="formData.isAnyTime === false">
                <el-table-column label="单次考试时间" prop="tableDateArr" width="380">
                  <template slot="header">
                    <span class="text-red-500">*</span>
                    单次考试时间
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :ref="`examSessions.${scope.$index}.tableDateArr`"
                      class="mt-20px"
                      label=""
                      label-width="0"
                      :prop="`examSessions.${scope.$index}.tableDateArr`"
                      :rules="[
                        {
                          required: true,
                          validator: (rule, value, callback) =>
                            tableValidatorDateArr(rule, value, callback, scope.$index),
                          trigger: ['change', 'blur'],
                        },
                      ]"
                    >
                      <el-date-picker
                        ref="tableDate"
                        class="w-full"
                        style="width: 100%"
                        v-model="scope.row.tableDateArr"
                        type="datetimerange"
                        size="small"
                        range-separator="-"
                        :start-placeholder="`${$t('开始日期')}`"
                        :end-placeholder="`${$t('结束日期')}`"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm"
                        @focus="tableDateFocus(scope.row)"
                        @change="(dateList) => tableDateChange(dateList, scope.row)"
                        :picker-options="pickerOptions"
                        clearable
                        :disabled="canRead"
                      />
                      <!-- :picker-options="pickerOptions" -->
                      <!-- :picker-options="tablePickerOptions" -->
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  label="考试时长(分钟)"
                  prop="examDuration"
                  show-overflow-tooltip
                  width="160"
                >
                  <template slot="header">
                    <span class="text-red-500">*</span>
                    考试时长(分钟)
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :ref="`examSessions.${scope.$index}.examDuration`"
                      class="mt-20px"
                      label=""
                      label-width="0"
                      :prop="`examSessions.${scope.$index}.examDuration`"
                      :rules="[
                        {
                          required: true,
                          message: '请输入',
                          trigger: ['change', 'blur'],
                        },
                      ]"
                    >
                      <el-input
                        disabled
                        maxlength="8"
                        show-word-limit
                        :placeholder="'请输入'"
                        v-model.number="scope.row.examDuration"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <span v-show="false"> {{ scope.row.examDuration }}</span>
                  </template>
                </el-table-column>
              </template>
              <el-table-column label="单次考试时长(分钟)" prop="examDuration" width="180" v-else>
                <template slot="header">
                  <span class="text-red-500">*</span>
                  单次考试时长(分钟)
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.examDuration`"
                    class="mt-20px relative"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.examDuration`"
                    :rules="[
                      {
                        required: true,
                        validator: (rule, value, callback) =>
                          examDurationValidator(rule, value, callback, scope.row),
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-popover
                      trigger="hover"
                      placement="top-start"
                      :content="scope.row.examDuration"
                      class="absoulate"
                    >
                      <el-input
                        maxlength="5"
                        show-word-limit
                        :placeholder="'请输入'"
                        v-model.number="scope.row.examDuration"
                        clearable
                        :disabled="canRead"
                        slot="reference"
                      ></el-input>
                    </el-popover>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                label="及格分数"
                prop="passingMark"
                show-overflow-tooltip
                width="160"
              >
                <template slot="header">
                  <span class="text-red-500">*</span>
                  及格分数
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.passingMark`"
                    class="mt-20px relative"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.passingMark`"
                    :rules="[
                      {
                        required: true,
                        message: '请输入',
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-popover
                      trigger="hover"
                      placement="top-start"
                      :content="scope.row.passingMark"
                      class="absoulate"
                    >
                      <el-input
                        maxlength="5"
                        show-word-limit
                        :placeholder="'请输入'"
                        v-model.number="scope.row.passingMark"
                        clearable
                        :disabled="canRead"
                        slot="reference"
                      ></el-input>
                    </el-popover>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="是否随机组卷"
                prop="randomlyExamPaper"
                show-overflow-tooltip
                width="120"
              >
                <template slot="header">
                  <span class="text-red-500">*</span>
                  是否随机组卷
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.randomlyExamPaper`"
                    class="mt-20px"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.randomlyExamPaper`"
                    :rules="[
                      {
                        required: true,
                        validator: (rule, value, callback) =>
                          isRandomValidator(rule, value, callback, scope.row),
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <el-select
                      v-model="scope.row.randomlyExamPaper"
                      class="w-full"
                      placeholder="请输入"
                      clearable
                      :disabled="canRead"
                    >
                      <el-option
                        v-for="item in changeTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column> -->
              <el-table-column label="考生" prop="examinee" show-overflow-tooltip min-width="420">
                <template slot="header">
                  <span class="text-red-500">*</span>
                  考生
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.examinee`"
                    class="mt-20px relative"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.examinee`"
                    :rules="[
                      {
                        required: true,
                        validator: (rule, value, callback) =>
                          personValidator(rule, value, callback, scope.row, 'examinee'),
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <!-- <MultiplePersonSelect
                      :disabled="canChange"
                      :disabledIds="examineeDisabledIds(scope.row)"
                      class="w-full"
                      placeholder="请输入"
                      v-model="scope.row.examinee"
                    ></MultiplePersonSelect> -->
                    <el-popover
                      trigger="hover"
                      placement="top-start"
                      :content="scope.row.examineeName"
                      class="absoulate"
                    >
                      <el-input
                        size="small"
                        v-model="scope.row.examineeName"
                        readonly
                        placeholder="请选择"
                        style="flex: 1"
                        :disabled="canChange"
                        slot="reference"
                      >
                        <template slot="append">
                          <el-button
                            @click="openTreeSelect(scope.row, 'examinee', canChange)"
                            type="primary"
                            :disabled="false"
                            >{{ canChange ? '查看' : '选择人员' }}</el-button
                          >
                          <el-button
                            class="!ml-30px"
                            v-if="!canChange"
                            @click="openTreeSelect(scope.row, 'examinee', canChange, true)"
                            type="primary"
                            :disabled="false"
                            >选择班组</el-button
                          >
                        </template>
                      </el-input>
                    </el-popover>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="监考人"
                prop="invigilator"
                show-overflow-tooltip
                width="200px"
              >
                <template slot="header">
                  监考人
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.invigilator`"
                    class="mt-20px"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.invigilator`"
                    :rules="[
                      {
                        required: false,
                        validator: (rule, value, callback) =>
                          personValidator(rule, value, callback, scope.row, 'invigilator'),
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <MultiplePersonSelect
                      :disabledIds="disabledIds(scope.row)"
                      :disabled="canRead"
                      class="w-full"
                      placeholder="请输入"
                      v-model="scope.row.invigilator"
                      v-if="false"
                    ></MultiplePersonSelect>
                    <el-input
                      size="small"
                      v-model="scope.row.invigilatorName"
                      readonly
                      placeholder="请选择"
                      style="flex:1"
                      :disabled="canRead"
                    >
                      <template slot="append">
                        <el-button
                          @click="openTreeSelect(scope.row, 'invigilator', canRead)"
                          type="primary"
                          :disabled="false"
                          >{{ canRead ? '查看' : '选择' }}</el-button
                        >
                      </template>
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column> -->
              <el-table-column label="判卷人" prop="judge" show-overflow-tooltip min-width="200px">
                <template slot="header">
                  <span class="text-red-500">*</span>
                  判卷人
                </template>
                <template slot-scope="scope">
                  <el-form-item
                    :ref="`examSessions.${scope.$index}.judge`"
                    class="mt-20px relative"
                    label=""
                    label-width="0"
                    :prop="`examSessions.${scope.$index}.judge`"
                    :rules="[
                      {
                        required: true,
                        validator: (rule, value, callback) =>
                          personValidator(rule, value, callback, scope.row, 'judge'),
                        trigger: ['change', 'blur'],
                      },
                    ]"
                  >
                    <!-- <MultiplePersonSelect
                      :disabledIds="disabledIds(scope.row)"
                      :disabled="canRead"
                      class="w-full"
                      placeholder="请输入"
                      v-model="scope.row.judge"
                    ></MultiplePersonSelect> -->
                    <el-popover
                      trigger="hover"
                      placement="top-start"
                      :content="scope.row.judgeName"
                      class="absoulate"
                    >
                      <el-input
                        size="small"
                        v-model="scope.row.judgeName"
                        readonly
                        placeholder="请选择"
                        style="flex: 1"
                        :disabled="canRead"
                        slot="reference"
                      >
                        <template slot="append">
                          <el-button
                            @click="openTreeSelect(scope.row, 'judge', canRead)"
                            type="primary"
                            :disabled="false"
                            >{{ canRead ? '查看' : '选择' }}</el-button
                          >
                        </template>
                      </el-input>
                    </el-popover>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-button
                    @click="delScence(scope.$index)"
                    :disabled="canRead || formData.examSessions.length === 1"
                    size="mini"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="w-full flex justify-center items-center mt-5 mb-5" v-if="pageType !== 'read'">
      <el-button
        type="primary"
        size="small"
        @click="submitForm('submit')"
        :loading="saveLoading"
        :disabled="pageLoading"
        >保存</el-button
      >
      <el-button @click="$emit('cancel')" size="small">取消</el-button>
    </div>
    <wiz-tree-select
      :visible.sync="userDialogVisible"
      :treeData="orgUserTree"
      treeCheckField="isActive"
      @save="addUser"
      :defaultSelectKeys="defaultSelectKeys"
      :treeExpandedKeys="treeExpandedKeys"
      :disabledKeys="disabledKeys"
      :title="userDialogTitle"
      treeNodeKey="key"
      repeatKey="id"
      :filterRepeat="true"
      :disabled="treeSelectDisabled"
    />
    <wiz-tree-select
      :visible.sync="teamUserDialogVisible"
      :treeData="teamUserTree"
      treeCheckField="isActive"
      @save="addUser"
      :defaultSelectKeys="defaultSelectKeys"
      :treeExpandedKeys="treeExpandedKeys"
      :disabledKeys="disabledKeys"
      :title="userDialogTitle"
      treeNodeKey="key"
      repeatKey="id"
      :filterRepeat="true"
      :disabled="treeSelectDisabled"
    />
  </div>
</template>

<script>
import { ExamPlanApi, ExamPaperApi } from '@wiz-api/exam-management'
import { TeamApi } from '@wiz-api/team-management'
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import dayjs from 'dayjs'
import { sumBy, cloneDeep, map, uniq, filter, find, random, chunk, isEmpty } from 'lodash'
import utils from '@/components/safety/enumField/utils'
// import MultiplePersonSelect from '@/components/safety/PersonSelect/MultiplePersonSelect'
import MultipleExamSelect from '../MultipleExamSelect'
import { typeList } from '../EnumField'

const teamApi = new TeamApi()
const examPlanApi = new ExamPlanApi()
const examPaperApi = new ExamPaperApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()

export default {
  name: 'exam-plan-form',
  components: {
    // MultiplePersonSelect,
    MultipleExamSelect,
  },
  props: {
    /**
     * @description: 上传传递的参数
     * @return {*}
     */
    pageType: {
      type: String,
      default: 'create',
    },
    rowId: {
      type: String,
      default: null,
    },
    operateData: {
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      teamUserDialogVisible: false,
      teamUserTree: [],
      integralTypeList: [
        {
          code: '1',
          displayName: '加分',
        },
        {
          code: '0',
          displayName: '扣分',
        },
      ],
      integralsList: [
        {
          code: '0.5',
          displayName: '0.5分',
        },
        {
          code: '1',
          displayName: '1分',
        },
        {
          code: '3',
          displayName: '3分',
        },
        {
          code: '6',
          displayName: '6分',
        },
        {
          code: '9',
          displayName: '9分',
        },
        {
          code: '12',
          displayName: '12分',
        },
      ],
      updateTable: random(1000),
      userDialogTitle: '',
      userDialogVisible: false,
      treeSelectDisabled: false,
      orgUserTree: [],
      treeExpandedKeys: [],
      disabledKeys: [],
      currentSelect: {
        row: null,
        field: '',
      },
      defaultSelectKeys: [],
      pickerOptions: {
        disabledDate(v) {
          return dayjs(v).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')
        },
      },

      changeTypeList: [
        { label: '是', value: true },
        { label: '否', value: false },
      ],
      // 当前索引值
      curParentIndex: null,
      // 当前选择关联试题的类型, 默认单选题
      curExamType: 0,
      tableLoading: false,
      // 关联题源
      pageLoading: false,
      pagerTypeList: [],
      typeList,
      // 风险点
      pointProps: {
        visible: false,
      },
      pointDialog: false,
      saveLoading: false,
      formData: {
        examName: '',
        examCode: '',
        examCategory: '',
        isAnyTime: false,
        associateIntegral: false,
        sponsor: '',
        examTotalScore: 0,
        integral: undefined,
        examNotice:
          '1.考试前请认真听监考员阅读考试须知，熟知考试规则和细节。\n2.保证考试环境的安静，提前确定好网络是否通畅，考试中通不要离开座位。\n3.考试前请将手机调至静音，打开勿扰模式防止出现意外，影响考试。\n4.考试严格按照考试时间和流程参加考试，不得提前或延后，未在现定时间参加考试者，视为自愿放弃考试资格。\n5.参加考试，除应自行准备好考试必需品外，其他物品(包括手机、手表等其他电子设备、书本及学习资料等) 禁止带入考试答题区。\n6.考生需严格遵守考场纪律，服从工作人员指挥，违反规定者，取消考试资格。\n7.考区内严禁使用通讯工具， 违反规定者按作弊处理。',
        dateArr: [],
        examSessions: [],
      },
      rules: {},
      allIds: [],
      lastestExamDate: [],
    }
  },
  computed: {
    canChange() {
      return ['read'].includes(this.pageType)
    },
    canRead() {
      return ['read', 'change'].includes(this.pageType)
    },
    tablePickerOptions() {
      return {
        disabledDate: this.disabledDateMethods,
      }
    },
    tableHeight() {
      return this.pageType === 'read' ? 'calc(100vh - 400px)' : 'calc(100vh - 450px)'
    },
    examineeDisabledIds() {
      return (row) => {
        // 考生 examinee 监考人 invigilator 判卷人 judge
        const invigilatorids = row.invigilator ? row.invigilator.split(',') : []
        const judge = row.judge ? row.judge.split(',') : []
        return Array.from(new Set([...invigilatorids, ...judge]))
      }
    },
    disabledIds() {
      return (row) => {
        return row.examinee ? row.examinee.split(',') : []
      }
    },
  },
  watch: {},
  methods: {
    associateIntegralChange(val) {
      if (val) {
        this.formData.integralType = ''
        this.formData.integrals = ''
      }
    },
    isAnyTimeChange() {
      // 解决切换后table列宽改变导致样式错乱
      this.updateTable = random(1000)
    },
    async getOrgUserTree() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserTree({})
      if (!err && res.length) {
        this.orgUserTree = this.processedTreeData(res)
        this.treeExpandedKeys = [res[0].organizationUnitId]
      }
    },
    processedTreeData(treeData) {
      const hanldeData = []
      treeData.forEach((item) => {
        const cloneTreeItem = cloneDeep(item)
        cloneTreeItem.label = item.organizationUnitName
        cloneTreeItem.id = item.organizationUnitId
        cloneTreeItem.key = item.organizationUnitId
        let hanldeChildren = []
        if (item.childen && item.childen.length) {
          hanldeChildren = this.processedTreeData(item.childen)
        }
        const activeUserList = filter(item.userList, (user) => {
          return user.isActive
        })
        const userList = map(activeUserList, (user) => {
          return {
            ...user,
            key: `${item.organizationUnitId}-${user.id}`,
            label: user.name,
          }
        })
        delete cloneTreeItem.userList
        delete cloneTreeItem.childen
        cloneTreeItem.children = [...hanldeChildren, ...userList]
        hanldeData.push(cloneTreeItem)
      })
      return hanldeData
    },

    addUser(data) {
      const ids = []
      const names = []
      data.forEach((item) => {
        ids.push(item.id)
        names.push(item.name)
      })
      this.currentSelect.row[this.currentSelect.field] = ids.join(',')
      this.$set(this.currentSelect.row, `${this.currentSelect.field}Name`, names.join(','))
    },
    async openTreeSelect(row, field, disabled, isTeam = null) {
      this.disabledKeys = []
      const titleObj = {
        sponsor: '发起人',
        judge: '判卷人',
        invigilator: '监考人',
        examinee: '考生',
      }
      this.treeSelectDisabled = disabled
      this.userDialogTitle = `选择${titleObj[field]}`
      this.currentSelect.row = row
      this.currentSelect.field = field
      this.defaultSelectKeys = row[field].split(',')
      if (field === 'judge') {
        this.disabledKeys = row.examinee.split(',')
      } else if (field === 'examinee') {
        this.disabledKeys = row.judge.split(',')
        if (this.pageType === 'change') {
          const [err, res] = await examPlanApi.getHaveParticipateUsers(row.id)
          if (!err) {
            this.disabledKeys.push(...res)
          }
        }
      }
      if (isTeam) {
        this.treeExpandedKeys = [this.teamUserTree[0].id]
        this.teamUserDialogVisible = true
      } else {
        this.treeExpandedKeys = [this.orgUserTree[0].organizationUnitId]
        this.userDialogVisible = true
      }
    },
    async getTotal() {
      const allIds = this.formData.examSessions.reduce((pre, item) => {
        if (item.usingExamPaper) {
          pre = [...pre, ...item.usingExamPaper.split(',')]
        }
        return pre
      }, [])
      // 禁用同一计划所选试卷   计划选择的所有试卷
      this.allIds = allIds
      if (allIds && allIds.length) {
        const [err, res] = await examPaperApi.getPaperSourceAllScore({
          examPaperIds: allIds,
        })
        if (!err) {
          this.formData.examTotalScore = res
        }
      } else {
        this.formData.examTotalScore = 0
      }
    },
    changeSelectionData(data, row) {
      // totalScore 试卷总分  passingscore 及格分数
      const passingMark = data.reduce((pre, item) => {
        pre = pre + Number(item.passingscore)
        return pre
      }, 0)
      this.$set(row, 'passingMark', passingMark)
      this.$set(row, 'suggestedExamDuration', sumBy(data, 'suggestedExamTime'))
      this.getTotal()
    },
    // 采用试卷校验
    paperValidator(rule, value, callback, index) {
      if (this.pageType === 'read') return
      if (!value) {
        callback(new Error('请输入!'))
        return
      }
      const allIds = this.formData.examSessions.reduce((pre, item, rowIndex) => {
        if (item.usingExamPaper && rowIndex !== index) {
          pre = [...pre, ...item.usingExamPaper.split(',')]
        }
        return pre
      }, [])
      const ids = value.split(',')
      const isRepert = allIds.some((id) => {
        return ids.indexOf(id) > -1
      })
      if (isRepert) {
        callback(new Error('同一计划下，试卷不能重复!'))
        return
      }
      callback()
    },
    isAlike(strA, strB) {
      const listA = strA ? strA.split(',') : []
      const listB = strB ? strB.split(',') : []
      const mergedArr = Array.from(new Set([...listA, ...listB]))
      return !(mergedArr.length === listA.length + listB.length)
    },
    // 监考人、判卷人不能和考生重复
    personValidator(rule, value, callback, row, type) {
      // 考生 examinee 监考人 invigilator 判卷人 judge
      if (!value && type !== 'invigilator') {
        callback(new Error('请输入!'))
        return
      }
      // 是否是考生
      if (type === 'examinee') {
        if (row.invigilator && this.isAlike(row.examinee, row.invigilator)) {
          callback(new Error('判卷人和考生不得重复!'))
        } else if (row.judge && this.isAlike(row.examinee, row.judge)) {
          callback(new Error('判卷人和考生不得重复!'))
        } else {
          callback()
        }
      } else if (row.examinee && this.isAlike(row.examinee, value)) {
        callback(new Error('判卷人和考生不得重复!'))
      } else {
        callback()
      }
    },
    // 场次名称校验
    nameValidator(rule, value, callback, index) {
      if (!value) {
        callback(new Error('请输入!'))
        return
      }
      const nameList = this.formData.examSessions.reduce((pre, item, rowIndex) => {
        if (rowIndex !== index) {
          pre = [...pre, item.examSessionName]
        }
        return pre
      }, [])
      if (nameList.indexOf(value) > -1) {
        callback(new Error('同一计划下，场次名称不能重复!'))
        return
      }
      callback()
    },

    // 是否随机试卷异步校验
    async isRandomValidator(rule, value, callback, row) {
      if (value === false) {
        callback()
        return
      }
      if (!value) {
        callback(new Error('请输入!'))
        return
      }
      if (row.usingExamPaper) {
        const [err, res] = await examPaperApi.getPaperSourceAllNum({
          examPaperIds: row.usingExamPaper.split(','),
        })
        if (!err) {
          if (res < 20) {
            this.$message.warning('所属题目不支持随机组卷，请最少选择20个题目!')
            callback(new Error('所属题目不支持随机组卷!'))
          } else {
            callback()
          }
        } else {
          callback(new Error('异步校验失败!'))
        }
      } else {
        callback(new Error('请先选择试卷!'))
      }
      // callback()
    },
    examDurationValidator(rule, value, callback, row) {
      if (!value) {
        callback(new Error('请输入!'))
        return
      }
      if (
        row.examDuration >
        dayjs(this.formData.examEndTime).diff(dayjs(this.formData.examStartTime), 'minute')
      ) {
        callback(new Error('时长不能超过考试计划时长!'))
        return
      }
      callback()
    },
    validatorDateArr(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入!'))
        return
      }
      if (new Date(value[0]) <= new Date() && this.pageType !== 'change') {
        callback(new Error('开始时间必须大于当前时间!'))
        return
      }
      if (value[0] >= value[1]) {
        callback(new Error('结束时间必须大于开始时间!'))
        return
      }
      if (this.pageType === 'change') {
        if (value[1] < this.lastestExamDate[1]) {
          callback(new Error('结束时间不能小于上一次结束时间!'))
          return
        }
      }
      callback()
    },
    tableValidatorDateArr(rule, value, callback, index) {
      if (!value) {
        callback('请输入')
        return
      }
      if (!this.formData.examStartTime || !this.formData.examEndTime) {
        callback('请先填写考试时间!')
        return
      }
      if (new Date(this.formData.examStartTime) > new Date(value[0])) {
        callback('单次开始考试时间不能早于考试开始时间!')
        return
      }
      if (new Date(this.formData.examEndTime) < new Date(value[1])) {
        callback('单次结束考试时间不能大于考试结束时间!')
        return
      }

      if (new Date(value[0]) <= new Date()) {
        callback(new Error('开始时间必须大于当前时间!'))
        return
      }
      if (value[0] >= value[1]) {
        callback(new Error('结束时间必须大于开始时间!'))
        return
      }

      // 新增开始时间不能大于上一列时间 结束时间不能早于下一列时间
      const lastcolumn = this.formData.examSessions[index - 1]
      const nextcolumn = this.formData.examSessions[index + 1]
      if (index === 0) {
        // 第一列
        if (nextcolumn && nextcolumn.singleExamStartTime && nextcolumn.singleExamEndTime) {
          if (value[1] >= nextcolumn.singleExamStartTime) {
            callback(new Error('结束时间必须早于下一场开始时间!'))
            return
          }
        }
      } else if (
        index > 0 &&
        index < this.formData.examSessions.length - 1 &&
        this.formData.examSessions.length >= 3
      ) {
        // 中间列
        if (
          nextcolumn &&
          nextcolumn.singleExamStartTime &&
          nextcolumn.singleExamEndTime &&
          value[1] >= nextcolumn.singleExamStartTime
        ) {
          callback(new Error('结束时间必须早于下一场开始时间!'))
          return
        }
        if (
          lastcolumn &&
          lastcolumn.singleExamStartTime &&
          lastcolumn.singleExamEndTime &&
          value[0] <= lastcolumn.singleExamEndTime
        ) {
          callback(new Error('开始时间必须大于上一场结束时间!'))
          return
        }
      } else if (
        index === this.formData.examSessions.length - 1 &&
        lastcolumn &&
        lastcolumn.singleExamStartTime &&
        lastcolumn.singleExamEndTime
      ) {
        // 最后一列
        if (value[0] <= lastcolumn.singleExamEndTime) {
          callback(new Error('开始时间必须大于上一场结束时间!'))
          return
        }
      }
      callback()
    },
    // 删除
    delScence(index) {
      this.formData.examSessions.splice(index, 1)
      this.getTotal()
    },

    // 考试场次
    addExamScene() {
      const lastName = this.formData.examSessions.at(-1)?.examSessionName
      const curName = /^D\d+$/.test(lastName)
        ? `D${parseInt(lastName.match(/\d+/)[0], 10) + 1}`
        : 'D1'
      this.formData.examSessions.push({
        invigilator: '',
        examinee: '',
        judge: '',
        randomlyExamPaper: false,
        examSessionName: curName,
        tableDateArr: this.formData.dateArr,
      })
      this.tableDateChange(this.formData.dateArr, this.formData.examSessions.at(-1))
    },

    // 获取详情
    async getDetail() {
      this.pageLoading = true
      const [err, res] = await examPlanApi.get(this.operateData.id)
      if (!err) {
        if (res.examStartTime && res.examEndTime) {
          res.dateArr = [new Date(res.examStartTime), new Date(res.examEndTime)]
        }
        this.lastestExamDate = [
          dayjs(res.examStartTime).format('YYYY-MM-DD HH:mm:ss'),
          dayjs(res.examEndTime).format('YYYY-MM-DD HH:mm:ss'),
        ]
        if (!res.examSessions) {
          res.examSessions = []
        }
        const userIds = []
        const data = res.examSessions.map((item) => {
          userIds.push(
            ...item.invigilator.split(','),
            ...item.examinee.split(','),
            ...item.judge.split(','),
            ...res.sponsor.split(',')
          )
          if (item.singleExamStartTime && item.singleExamEndTime) {
            item.tableDateArr = [
              new Date(item.singleExamStartTime),
              new Date(item.singleExamEndTime),
            ]
            if (!res.isAnyTime) {
              this.tableDateChange(item.tableDateArr, item)
            }
          }
          return item
        })
        if (!res.integral) {
          res.integral = undefined
        }
        this.formData = { ...res, examSessions: data }
        this.getUserList(uniq(userIds))
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
      this.pageLoading = false
    },
    async getUserList(ids) {
      if (ids.length === 0) return
      const filterIds = filter(ids, (item) => {
        const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
        return uuidPattern.test(item)
      })
      const spliceNum = 40
      const chunkList = chunk(filterIds, spliceNum)
      const promiseList = []
      chunkList.forEach((item) => {
        promiseList.push(
          eafOrganizationUnitUserApi.getOrganizationUnitUserList({
            userIdList: item,
            skipCount: 0,
            maxResultCount: spliceNum,
          })
        )
      })
      Promise.all(promiseList).then((data) => {
        const userList = []
        data.forEach((item) => {
          if (!item[0]) {
            userList.push(...item[1].items)
          }
        })
        this.formData.examSessions.forEach((item) => {
          const examineeName = map(item.examinee.split(','), (id) => {
            const user = find(userList, { id })
            return user ? user.name : ''
          }).join(',')
          this.$set(item, 'examineeName', examineeName)
          const judgeName = map(item.judge.split(','), (id) => {
            const user = find(userList, { id })
            return user ? user.name : ''
          }).join(',')
          this.$set(item, 'judgeName', judgeName)
          const invigilatorName = map(item.invigilator.split(','), (id) => {
            const user = find(userList, { id })
            return user ? user.name : ''
          }).join(',')
          this.$set(item, 'invigilatorName', invigilatorName)
        })
        const sponsorName = map(this.formData.sponsor.split(','), (id) => {
          const user = find(userList, { id })
          return user ? user.name : ''
        }).join(',')
        this.$set(this.formData, 'sponsorName', sponsorName)
      })
    },
    // 日期改变
    disabledDateMethods(v) {
      if (!this.formData.examStartTime || !this.formData.examEndTime) {
        return false
      }
      return (
        dayjs(this.formData.examStartTime).format('YYYY-MM-DD') > dayjs(v).format('YYYY-MM-DD') ||
        dayjs(v).format('YYYY-MM-DD') > dayjs(this.formData.examEndTime).format('YYYY-MM-DD')
      )
    },
    dateFocus() {
      if (this.formData.dateArr.length === 0) {
        this.formData.examStartTime = dayjs().format('YYYY-MM-DD HH:mm:00')
        this.formData.examEndTime = dayjs().format('YYYY-MM-DD 23:59:00')
        this.formData.dateArr = [this.formData.examStartTime, this.formData.examEndTime]
      }
    },
    dateChange(value) {
      if (value && value.length) {
        if (this.pageType === 'change') {
          this.formData.examStartTime = this.lastestExamDate[0]
          this.formData.dateArr[0] = this.lastestExamDate[0]
        } else {
          this.formData.examStartTime = dayjs(value[0]).format('YYYY-MM-DD HH:mm:ss')
        }
        this.formData.examEndTime = dayjs(value[1]).format('YYYY-MM-DD HH:mm:ss')
        this.formData.examSessions.forEach((item) => {
          if (isEmpty(item.tableDateArr)) {
            item.tableDateArr = [this.formData.examStartTime, this.formData.examEndTime]
            this.tableDateChange(item.tableDateArr, item)
          }
        })
      }
    },
    tableDateFocus(row) {
      if (isEmpty(row.tableDateArr)) {
        row.singleExamStartTime = dayjs().format('YYYY-MM-DD HH:mm:00')
        row.singleExamEndTime = dayjs().format('YYYY-MM-DD 23:59:00')
        this.$set(row, 'tableDateArr', [row.singleExamStartTime, row.singleExamEndTime])
        const minute = Math.floor(
          Math.abs(new Date(row.singleExamEndTime) - new Date(row.singleExamStartTime)) / 60000
        )
        this.$set(row, 'examDuration', minute)
      }
    },
    tableDateChange(value, row) {
      if (value && value.length) {
        row.singleExamStartTime = dayjs(value[0]).format('YYYY-MM-DD HH:mm:ss')
        row.singleExamEndTime = dayjs(value[1]).format('YYYY-MM-DD HH:mm:ss')
        // 计算考试时长
        const minute = Math.floor(Math.abs(new Date(value[1]) - new Date(value[0])) / 60000)
        this.$set(row, 'examDuration', minute)
        // row.examDuration = minute
      }
    },
    // 添加风险测点
    addRiskPoint(data) {
      this.sourcesDangerRecognitionPlanTaskDtos[this.curParentIndex].children = [
        ...data,
        ...this.sourcesDangerRecognitionPlanTaskDtos[this.curParentIndex].children,
      ]
      this.pointProps.visible = false
      this.pointDialog = false
    },
    /**
     * 表单提交
     */
    async submitForm() {
      let err = null
      let res = null
      this.$refs.form.validate(async (valid, object) => {
        if (valid) {
          // 处理日期格式
          if (this.formData.creationTime) {
            this.formData.creationTime = dayjs(this.formData.creationTime).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
          if (this.formData.examEndTime) {
            this.formData.examEndTime = dayjs(this.formData.examEndTime).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
          if (this.formData.examStartTime) {
            this.formData.examStartTime = dayjs(this.formData.examStartTime).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
          this.formData.examSessions.forEach((item) => {
            // 是任意时间考试将考试时间赋值单次考试时长
            if (this.formData.isAnyTime === true) {
              item.singleExamEndTime = this.formData.examEndTime
              item.singleExamStartTime = this.formData.examStartTime
            }
            if (item.singleExamEndTime) {
              item.singleExamEndTime = dayjs(item.singleExamEndTime).format('YYYY-MM-DD HH:mm:ss')
            }
            if (item.singleExamStartTime) {
              item.singleExamStartTime = dayjs(item.singleExamStartTime).format(
                'YYYY-MM-DD HH:mm:ss'
              )
            }
          })
          if (!(this.formData.examSessions && this.formData.examSessions.length)) {
            this.$message({
              showClose: true,
              message: '请添加考试场次',
              type: 'warning',
            })
            return
          }
          if (this.pageType === 'change') {
            ;[err, res] = await examPlanApi.changePlan({
              body: {
                id: this.formData.id,
                endTime: this.formData.examEndTime,
                sessions: map(this.formData.examSessions, (item) => {
                  return {
                    id: item.id,
                    examinee: item.examinee.split(','),
                  }
                }),
              },
            })
            if (!err) {
              this.$message({
                showClose: true,
                message: '变更成功',
                type: 'success',
              })
              this.$emit('refreshList')
            }
          } else if (this.formData.id) {
            // 编辑
            ;[err, res] = await examPlanApi.update(this.formData.id, {
              body: this.formData,
            })
            if (!err) {
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
              this.$emit('refreshList')
            }
          } else {
            // 新增
            ;[err, res] = await examPlanApi.create({
              body: this.formData,
            })
            if (!err) {
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
              this.$emit('refreshList')
            }
          }
        } else {
          // 验证不通过定位到第一个错误的地方
          const keyList = Object.keys(object)
          if (keyList && keyList.length) {
            const el = this.$refs[keyList[0]].$el
            el.scrollIntoView(true)
          }
        }
      })
    },
    // 获取人员信息
    async getTeamUserInfo(ids) {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        userIdList: ids,
      })
      if (!err) {
        return res.items
      }
      return []
    },
    // 获取班组人员列表
    async getTeamUserTree() {
      const [err, res] = await teamApi.pagedListQuery({
        skipCount: 0,
        maxResultCount: 999,
        isEnabledPermissions: false,
      })
      if (!err) {
        const teamList = res.items
        for (let i = 0; i < teamList.length; i += 1) {
          const item = teamList[i]
          const users = await this.getTeamUserInfo(_.map(item.members, 'accountId'))
          this.$set(teamList[i], 'userList', users)
        }
        this.teamUserTree = this.processedTeamTreeData(teamList)
        this.treeExpandedKeys = [teamList[0].id]
      }
    },
    processedTeamTreeData(treeData) {
      const hanldeData = []
      treeData.forEach((item) => {
        const cloneTreeItem = cloneDeep(item)
        cloneTreeItem.label = item.name
        cloneTreeItem.id = item.id
        cloneTreeItem.key = item.id
        const activeUserList = filter(item.userList, (user) => {
          return user.isActive
        })
        const userList = map(activeUserList, (user) => {
          return {
            ...user,
            key: `${item.id}-${user.id}`,
            label: user.name,
          }
        })
        delete cloneTreeItem.userList
        delete cloneTreeItem.childen
        cloneTreeItem.children = [...userList]
        hanldeData.push(cloneTreeItem)
      })
      return hanldeData
    },
  },
  created() {
    utils.getDataCategory(['ExamManagement.DataCategory.ExamType'], ['pagerTypeList'], this)
    this.getOrgUserTree()
    this.getTeamUserTree()
  },
  mounted() {
    if (this.pageType !== 'create') {
      this.getDetail()
    } else {
      this.addExamScene()
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      this.formData.sponsor = userInfo?.profile.sub
      this.formData.sponsorName = userInfo?.profile.given_name
    }
  },
}
</script>

<style scoped lang="scss">
.custom-height {
  height: calc(100% - 95px);
}

.detail-height {
  height: calc(100% - 50px);
}
</style>
